const Menu = [
    {
        id:1,
        name:"Girl",
        image:require('./images/50.jpg'),
        description:"hello my name is jullie how are you ",
        category:"girl"
    },
    {
        id:2,
        name:"doggie",
        category:"dog",

        image:require('./images/dog1.jpg'),
        description:"hello my name is doggie how are your , i think your smart"
    },
    {
        id:17,
        name:"dog",
        category:"dog",

        image:require('./images/8.jpg'),
        description:"hello my name is doggie how are your , i think your smart"
    },
    {
        id:2,
        name:"home",
        category:"home",

        image:require('./images/home10.avif'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
 
    {
        id:4,
        name:"doggie",
        category:"dog",

        image:require('./images/dog11.avif'),
        description:"hello my name is doggie how are your , i think your smart"
    },
    {
        id:10,
        name:"cat",
        category:"cat",

        image:require('./images/cat2.webp'),
        description:"hello my name is cat how are your , i think your smart"
    },
 
    {
        id:3,
        name:"Girl",
        image:require('./images/g2.avif'),
        category:"girl",

        description:"hello my name is jullie how are you "
    },
    {
        id:4,
        name:"dog",
        category:"dog",

        image:require('./images/dog 2.jpg'),
        description:"hello my name is doggie how are your , i think your smart"    },
    {
        id:5,
        name:"girl",
        category:"girl",

        image:require('./images/Beautiful-Girl-Selfie-Images-17-wpp1636997396888.jpg'),
        description:"hello my name is jullie how are you "

    },
    {
        id:1,
        name:"home",
        category:"home",

        image:require('./images/home1.jpg'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
 
    {
        id:3,
        name:"home",
        category:"home",

        image:require('./images/home11.avif'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
    {
        id:4,
        name:"home",
        category:"home",

        image:require('./images/home13.avif'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
    {
        id:5,
        name:"home",
        category:"home",

        image:require('./images/home12.avif'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
    {
        id:6,
        name:"home",
        category:"home",

        image:require('./images/home2.jpg'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
    {
        id:7,
        name:"home",
        category:"home",

        image:require('./images/home3.jpeg'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
    {
        id:8,
        name:"home",
        category:"home",

        image:require('./images/home4.jpg'),
        description:"here are the most beutiful home you see if you want to buy this hous  $80 thousand only"
    },
    {
        id:8,
        name:"cat",
        category:"cat",

        image:require('./images/cat1.jpg'),
        description:"hello my name is cat how are your , i think your smart"
    },
  
    {
        id:12,
        name:"cat",
        category:"cat",

        image:require('./images/cat3.jpg'),
        description:"hello my name is cat how are your , i think your smart"
    },
    {
        id:13,
        name:"cat",
        category:"cat",

        image:require('./images/t4.png'),
        description:"hello my name is Cat how are your , i think your smart"
    },
    {
        id:14,
        name:"dog",
        category:"dog",

        image:require('./images/dog5.jpg'),
        description:"hello my name is doggie how are your , i think your smart"
    },
    {
        id:15,
        name:"dog",
        category:"dog",

        image:require('./images/dog6.webp'),
        description:"hello my name is doggie how are your , i think your smart"
    },
    {
        id:16,
        name:"dog",
        category:"dog",

        image:require('./images/7.jpeg'),
        description:"hello my name is doggie how are your , i think your smart"
    },
    {
        id:3,
        name:"doggie",
        category:"dog",

        image:require('./images/dog10.avif'),
        description:"hello my name is doggie how are your , i think your smart"
    },
    {
        id:5,
        name:"doggie",
        category:"dog",

        image:require('./images/dog12.avif'),
        description:"hello my name is doggie how are your , i think your smart"
    },


]

export default Menu